import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Editor from './pages/Editor';
import AuthCallback from './pages/AuthCallback';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './hooks/useAuth';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback synchronously during render to prevent race conditions
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Editor />} />
      <Route path="/dashboard" element={<Editor />} />
    </Routes>
  );
}

function App() {
  React.useEffect(() => {
    // Hide Emergent badge that interferes with UI
    const hide = () => {
      const el = document.getElementById('emergent-badge');
      if (el) el.style.setProperty('display', 'none', 'important');
    };
    hide();
    const t = setInterval(hide, 800);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

export default App;
